import React, { useContext } from 'react';

export type AddonCategoryFormType = {
  meal_addon_category_id: string[];
  brand_id: string[];
  parent_meal_id: string[];
  meal_addon_category_options: { title: string; value: string }[];
  addons: { base_meal_id: string; default: boolean; name: string; amount: string }[];
};

type NewMealAddonType = {
  newAddonData: AddonCategoryFormType;
  setNewAddonData: (item: AddonCategoryFormType) => void;
  isValid: boolean;
  setIsValid?: (value: boolean) => void;
};

export const NewAddonContext = React.createContext({} as NewMealAddonType);

const useNewAddonContext = () => {
  const context = useContext(NewAddonContext);
  return context;
};

export default useNewAddonContext;
